import 'css-chunk:src/applications/AffiliatesApp/components/MemberTable/AffiliatesMemberTable.scss';export default {
  "textLeft": "_textLeft_l6lo9_8",
  "customInputBoxLength": "_customInputBoxLength_l6lo9_32"
};